import type { ExportGrantEntity, ExportViewEntity } from '../../domain/entities/ExportAccessEntity.js';
import type { IExportAccessRepository } from '../../domain/repositories/IExportAccessRepository.js';
import { ExportAccessRemoteDataSource } from '../datasources/ExportAccessRemoteDataSource.js';

export class ExportAccessRepository implements IExportAccessRepository {
  constructor(private readonly ds: ExportAccessRemoteDataSource) {}

  async listExportViews(): Promise<ExportViewEntity[]> {
    const rows = await this.ds.listExportViews();
    return rows.map((r: any) => ({
      exportKey: r.export_key,
      viewName: r.view_name,
      description: r.description ?? null,
    }));
  }

  async listGrants(): Promise<ExportGrantEntity[]> {
    const rows = await this.ds.listGrants();
    return rows.map((r: any) => ({
      orgId: r.org_id,
      orgName: r.org?.name,
      exportKey: r.export_key,
      createdAt: r.created_at,
    }));
  }

  async createGrant(input: { orgId: string; exportKey: string }): Promise<void> {
    await this.ds.createGrant(input.orgId, input.exportKey);
  }

  async deleteGrant(input: { orgId: string; exportKey: string }): Promise<void> {
    await this.ds.deleteGrant(input.orgId, input.exportKey);
  }
}
